import { format, addDays } from "date-fns";
import { CalendarX, ChevronLeft, ChevronRight, Trash2, Users } from "lucide-react";

export function MealPlanPageHeader({
  setShowClearModal,
  setShowClearDayModal,
  setShowMobileClearModal,
  setShowHouseholdModal,
  totalItems,
  weekStart,
  weekOffset,
  onPrevWeek,
  onNextWeek,
  onGoToToday,
  isToday,
}) {
  const isPastWeek = weekOffset < 0;

  const weekLabel =
    weekOffset === 0 ? "This week" :
    weekOffset === 1 ? "Next week" :
    weekOffset === -1 ? "Last week" :
    weekOffset > 1 ? `${weekOffset} weeks ahead` :
    `${Math.abs(weekOffset)} weeks ago`;

  return (
    <div className="bg-white border-b border-gray-200 px-4 md:px-8 pt-4 pb-2 md:py-6">
      <div className="flex flex-col gap-3 md:gap-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">
            Meal Plan
          </h1>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowHouseholdModal(true)}
              className="px-3 py-2 text-sm font-medium text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-50 transition-colors flex items-center gap-2 whitespace-nowrap"
              title="Set household size"
            >
              <Users className="w-4 h-4" />
              <span className="hidden sm:inline">Household</span>
            </button>

            {!isPastWeek && (
              <>
                <button
                  disabled={totalItems === 0}
                  onClick={() => setShowClearDayModal(true)}
                  className="hidden md:flex px-3 py-2 text-sm font-medium text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  <CalendarX className="w-4 h-4" />
                  Clear Day
                </button>

                <button
                  disabled={totalItems === 0}
                  onClick={() => setShowClearModal(true)}
                  className="hidden md:flex px-3 py-2 text-sm font-medium text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  <Trash2 className="w-4 h-4" />
                  Clear All
                </button>

                <button
                  disabled={totalItems === 0}
                  onClick={() => setShowMobileClearModal(true)}
                  className="md:hidden px-3 py-2 text-sm font-medium text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors flex items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  <Trash2 className="w-4 h-4" />
                  Clear
                </button>
              </>
            )}
          </div>
        </div>

        {/* Week Navigator */}
        <div className="flex items-center justify-center gap-3 md:justify-start">
          <button
            onClick={onPrevWeek}
            className="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
            aria-label="Previous week"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>

          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-900">
              {format(weekStart, "MMM d")} – {format(addDays(weekStart, 6), "MMM d, yyyy")}
            </span>
            {weekOffset !== 0 && (
              <span
                className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                  isPastWeek
                    ? "text-amber-700 bg-amber-100"
                    : "text-gray-500 bg-gray-100"
                }`}
              >
                {weekLabel}
              </span>
            )}
          </div>

          <button
            onClick={onNextWeek}
            className="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
            aria-label="Next week"
          >
            <ChevronRight className="w-4 h-4" />
          </button>

          {!isToday && (
            <button
              onClick={onGoToToday}
              className="hidden md:inline-flex ml-2 px-3 py-1 text-xs font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Today
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
